import { render, staticRenderFns } from "./duijie.vue?vue&type=template&id=46e9fab9&scoped=true&"
import script from "./duijie.vue?vue&type=script&lang=ts&"
export * from "./duijie.vue?vue&type=script&lang=ts&"
import style0 from "./duijie.vue?vue&type=style&index=0&id=46e9fab9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e9fab9",
  null
  
)

export default component.exports